import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, Callout, Tooltip} from "@blueprintjs/core";

import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'

import { SLTranInfo, StkCodeInfo } from './Types'   // 20230327
import { SystemHeader, ClientPicker } from './CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;

var UserID: string;
var PgmCode = "SL004" ;
var isReqAuth2:boolean = false ;
var isReqValueLimitAuth2:boolean = false ;

interface SLTranViewProps {
    gsb: AxiosInstance,
    LocationTran: SLTranInfo,
    LocationTran0: SLTranInfo, 
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}


function SLTranView({ gsb, LocationTran = {} as SLTranInfo, LocationTran0 = {} as SLTranInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 }: SLTranViewProps) {

    const { t, i18n } = useTranslation();    
    
    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)
    const [isCanDelete, setisCanDelete] = useState(true)
    const [isDeletePress2, setisDeletePress2] = useState(false)

    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    const [StkNameValue, setStkNameValue] = useState("")
    
    
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, LocationTran])

    const onReqAuthDelRec = () => {
        (async () => {
            try {
                const res2 = await gsb.post('/PgmAccess', {
                    userId: AuthUser,
                    password: password,
                    cIPAddr: "",
                    cReqUser: GsbFlag.UserID,
                } )
                if (res2.data.ok) {
                    setAuthUser("")
                    setPassword("")

                    const res = await gsb.post('/Master', {
                        sb_data: {
                            userId: AuthUser,
                            password: password,
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "ReqUserGroupAccessReqAuth"
                    })
                    console.log("onReqAuthDelRec res.data.data", res.data.data);
                    if ( res.data.ok && res.data.data[0].d_Can_DeleteMaster == "Y") {
                        onDelete();
                        
                    } else {
                        utils.showWarn("Authorization failed")
                        setisShowAlert2(true)
                        setShowAlert2Msg("Authorization failed")
                    }

                } else {
                    utils.showError(res2.data.message)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res2.data.message)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()

    }

    useEffect(() => {
        (async () => {
            try {
                // get Stk Qty Info
                //console.log("SLTranEdit LocationTran.d_StkNo: ", LocationTran.d_StkNo) 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "GetStkInfo", cStkNo: LocationTran.d_StkNo})
                //console.log("SLTranEdit GetStkQtyInfo data : ", res.data.data) 
                
                if ( LocationTran.d_StkNo.trim().length > 0 && res.data.count > 0 )
                {
                    setStkNameValue(res.data.data[0].d_StkName)
                } else { 
                    setStkNameValue("")
                }
               
            } catch (error) {
                showErrorBox(error)
            }
        })()

    }, [gsb, LocationTran.d_StkNo])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_StkNo" in LocationTran)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            { ViewMode === "V" && <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
            </div> }
            { ViewMode === "L" && <div>
                Stock : {LocationTran.d_StkNo}, {LocationTran.d_Tran_type} 
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (LocationTran0.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(LocationTran0.d_AuthDate, "3")} {LocationTran0.d_AuthTime} User {LocationTran0.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Tran Type" labelFor="inputTranType" labelInfo="*">
                    <InputGroup readOnly value={LocationTran.d_Tran_type} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationTran0.d_Tran_type.toString() == "") && 
                    <div id="DispText2" > {LocationTran0.d_Tran_type} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Stock No." labelFor="inputStkNo">
                    <InputGroup readOnly value={LocationTran.d_StkNo} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationTran0.d_StkNo.toString() == "") && 
                    <div id="DispText2" > {LocationTran0.d_StkNo} </div> }
                </FormGroup>
                <FormGroup className="Col-3-5" label="Stock Code / Name" labelFor="inputStkName">
                    <div>
                    <div id="DispText">{LocationTran.d_StkCode}</div>
                    <div id="DispText">{StkNameValue}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Tran Date" labelFor="inputd_Tran_datee">
                        <InputGroup readOnly value= {utils.dispDate(LocationTran.d_Tran_date, GsbFlag.dateFormat)} />
                        { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationTran0.d_Tran_date.toString() == "") && 
                        <div id="DispText2" > {utils.dispDate(LocationTran0.d_Tran_date, GsbFlag.dateFormat)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Description" labelFor="inputDescription">
                    <InputGroup readOnly value={LocationTran.d_Remark} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationTran0.d_Remark.toString() == "") && 
                        <div id="DispText2" > {LocationTran0.d_Remark} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="To Location" labelFor="inputToLocation">
                    <InputGroup readOnly value={LocationTran.d_To_Location} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationTran0.d_To_Location.toString() == "") && 
                    <div id="DispText2" > {LocationTran0.d_To_Location} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="From Location" labelFor="inputFmLocation">
                    <InputGroup readOnly value={LocationTran.d_Fm_Location} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationTran0.d_Fm_Location.toString() == "") && 
                    <div id="DispText2" > {LocationTran0.d_Fm_Location} </div> }
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Tran Qty" labelFor="inputTranQty">
                    <InputGroup readOnly value={utils.numToString2(LocationTran.d_TranQty)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationTran0.d_TranQty.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(LocationTran0.d_TranQty)} </div> }
                </FormGroup>
            </div>

            <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>

        </div>
    )
}

interface SLTranEditProps {
    gsb: AxiosInstance,
    LocationTran?: SLTranInfo,
    isNew?: boolean,
    onSave?: (stk: SLTranInfo) => void,
    onCancel?: () => void;
}

function SLTranEdit({ gsb, LocationTran = {} as SLTranInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: SLTranEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<SLTranInfo>()
 
    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [TranTypeValue, setTranTypeValue] = useState(LocationTran.d_Tran_type)
    const [DescValue, setDescValue] = useState(LocationTran.d_Remark)

    const [Caretdown2, setCaretdown2] = useState(false)
    const [StkCodeList, setStkCodeList] = useState([] as StkCodeInfo[])
    const [StkNoValue, setStkNoValue] = useState(LocationTran.d_StkNo)
    const [StkCodeValue, setStkCodeValue] = useState(LocationTran.d_StkCode)
    const [StkNameValue, setStkNameValue] = useState("")


    const [TranQtyValue, setTranQtyValue] = useState(utils.numToString2(LocationTran.d_TranQty))

 
    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastEdit UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, LocationTran])

    useEffect(() => {
        (async () => {
            try {
                // get Stock Code List
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "StkCodeList"})
                //console.log("StkCodeList: ", res.data.data) 
                setStkCodeList(res.data.data)
                //console.log("set StkCodeList: ", StkCodeList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        // Call reset to get the values of record SLTranInfo 
        if ("d_StkNo" in LocationTran) {
            reset(LocationTran)
        }
    }, [LocationTran, reset])



    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    
    useEffect(() => {
        (async () => {
            try {
                // get Stk Qty Info
                //console.log("SLTranEdit LocationTran.d_StkNo: ", LocationTran.d_StkNo) 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "GetStkInfo", cStkNo: StkNoValue})
                //console.log("SLTranEdit GetStkQtyInfo data : ", res.data.data) 
                
                if ( StkNoValue.trim().length > 0 && res.data.count > 0 )
                {
                    setStkCodeValue(res.data.data[0].d_StkCode)
                    setStkNameValue(res.data.data[0].d_StkName)
                } else { 
                    setStkCodeValue("")
                    setStkNameValue("")
                }
               
            } catch (error) {
                showErrorBox(error)
            }
        })()

    }, [gsb, StkNoValue])


    if (! isNew && ! ("d_StkNo" in LocationTran)) return null


    
    const onSubmit = (data: SLTranInfo) => {

        //console.log("SLTranedit onsubmit data: ", data)
        //console.log("SLTranedit onsubmit StkPrice: ", StkPrice)
        //console.log("SLTranedit onsubmit data.d_StkPrice: ", data.d_StkPrice)

        // put value to json/field before write database dbf

       
        data._recordNo = LocationTran._recordNo
        data.d_Tran_type = TranTypeValue
        data.d_StkNo = StkNoValue ;
        data.d_Remark = DescValue

        data.d_TranQty = utils.StringToNum2(TranQtyValue);


        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }
        
        ;

        (async () => {
            try {
                //console.log("call SLTranedit data", data)
                //console.log("call SLTranedit isNew", isNew)
                const res = await gsb.post('/SLUser', {sb_data: data, cPgmId: "SLTran", cAction: "SLTranValidate", isNew: isNew})
                //console.log("SLTranedit res.data.ok", res.data.ok)
                //console.log("SLTranedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

        //onSave(data)
    }



    const StkRenderer: ItemRenderer<StkCodeInfo> = (stk, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${stk.d_StkCode}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={stk.d_StkNo}
                key={stk.d_StkNo}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const StkPredicate: ItemPredicate<StkCodeInfo> = (query, stk, _index, exactMatch) => {
        const normalizedText = `${stk.d_StkNo} - ${stk.d_StkCode}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const StkValueRenderer = (stk: StkCodeInfo) => {
        return stk.d_StkNo
    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const handleChang2e = (field: string) => {
        if (field ==="D")
        {
           
        }
        else if (field ==="W")
        {

        }    
       
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Tran Type" labelFor="inputTranType" labelInfo="*">
                    <select  id="inputTranType"  
                        value={TranTypeValue}
                        autoFocus
                        disabled={! isNew}
                        onChange={utils.handleStringChange(s => setTranTypeValue(s)) }
                    >
                        <option value="I">I: In</option>            
                        <option value="O">O: Out</option>      
                        <option value="T">T: Transfer</option>      
                    </select>
                </FormGroup>
            </div>
            <div className="Row">
                { ! Caretdown2 && 
                    <FormGroup className="Col-1-1" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                        <InputGroup id="inputStkNo" disabled={! isNew} value={StkNoValue} defaultValue="" placeholder="Stock No. ..." onChange={utils.handleStringChange(s => setStkNoValue(s)) } inputRef={register({ required: true , maxLength: 6}) } />
                        {errors.d_StkNo && errors.d_StkNo.type === "required" && <span id="Err_msg">Stock No. cannot be Blank</span>}
                        {errors.d_StkNo && errors.d_StkNo.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                        {errors.d_StkNo && errors.d_StkNo.types && <span id="Err_msg">{errors.d_StkNo.types.message}</span>}
                    </FormGroup>
                }
                { Caretdown2 && 
                    <FormGroup className="Col3-1-1" label="Stock No." labelFor="inputStkNo" >
                        <Suggest
                            inputProps={{ placeholder: "Please choose Stock No. ..." }}
                            selectedItem={StkCodeList.find((stk1) => stk1.d_StkNo === StkNoValue)}
                            items={StkCodeList}
                            itemRenderer={StkRenderer}
                            itemPredicate={StkPredicate}
                            inputValueRenderer={StkValueRenderer}
                            onItemSelect={(Stk) => { setStkNoValue(Stk.d_StkNo) ; setStkCodeValue(Stk.d_StkCode) ; setStkNameValue(Stk.d_StkName) ; setCaretdown2(!Caretdown2) }}
                        />
                    </FormGroup>
                }
                {/* <span onClick={() => { setCaretdown2(!Caretdown2) } }> {imgCaretdown} </span> */}
                <FormGroup className="Col-3-5" label="Stock Code / Name" labelFor="inputStkName">
                    <div>
                    <div id="DispText">{StkCodeValue}</div>
                    <div id="DispText">{StkNameValue}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Tran Date" labelFor="inputd_Tran_datee">
                    <InputGroup id="inputd_Tran_datee" name="d_Tran_date" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_Tran_date && errors.d_Tran_date.types && <span id="Err_msg">{errors.d_Tran_date.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Description" labelFor="inputDescription">
                    <InputGroup id="inputDescription" autoFocus={! isNew} value={DescValue} defaultValue="" placeholder="Description ..." onChange={utils.handleStringChange(s => setDescValue(s)) } inputRef={register({ maxLength: 30}) } />
                    {errors.d_Remark && errors.d_Remark.type === "maxLength" && <span id="Err_msg">Max length is 30</span>}
                    {errors.d_Remark && errors.d_Remark.types && <span id="Err_msg">{errors.d_Remark.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="To Location" labelFor="inputToLocation">
                    <InputGroup id="inputToLocation" disabled={TranTypeValue == "O"} name="d_To_Location" defaultValue="" placeholder="From Location ..." inputRef={register({ maxLength: 8}) } />
                    {errors.d_To_Location && errors.d_To_Location.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_To_Location && errors.d_To_Location.types && <span id="Err_msg">{errors.d_To_Location.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="From Location" labelFor="inputFmLocation">
                    <InputGroup id="inputFmLocation" disabled={TranTypeValue == "I"} name="d_Fm_Location" defaultValue="" placeholder="To Location ..." inputRef={register({ maxLength: 8}) } />
                    {errors.d_Fm_Location && errors.d_Fm_Location.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_Fm_Location && errors.d_Fm_Location.types && <span id="Err_msg">{errors.d_Fm_Location.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Tran Qty" labelFor="inputTranQty">
                    <InputGroup className="inputNumberNoSpin" id="inputTranQty" value={TranQtyValue} onChange={utils.handleStringChange(n => setTranQtyValue(n))}  />
                    {errors.d_TranQty && errors.d_TranQty.type === "min" && <span id="Err_msg">Quantity sholud be greater than 0 </span>}
                    {errors.d_TranQty && errors.d_TranQty.types && <span id="Err_msg">{errors.d_TranQty.types.message}</span>}
                </FormGroup>
            </div>
        </form>
    )
}

interface SLTranMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function SLTranMain({ gsb }: SLTranMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { StkNo: defaultSearchValue = "" }: { StkNo: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as SLTranInfo[])

    const [searchKey, setSearchKey] = useState("_recordNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchAcName, setsearchAcName] = useState("")
    const [searchStkNo, setsearchStkNo] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentLocationTran, setcurrentLocationTran] = useState({} as SLTranInfo)
    const [BlankLocationTran, setBlankLocationTran] = useState({} as SLTranInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as SLTranInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as SLTranInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

 
    //gsb default value
    BlankLocationTran._recordNo = 0
    BlankLocationTran.d_Tran_type = "T"
    BlankLocationTran.d_StkNo = ""
    BlankLocationTran.d_StkCode = ""
    BlankLocationTran.d_Remark = ""
    BlankLocationTran.d_TranQty = 0
    BlankLocationTran.d_Fm_Location = ""
    BlankLocationTran.d_To_Location = ""


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SLTranMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SLTranMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("SLTranMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SLTranMain disp GsbFlag: ", GsbFlag)
                //console.log("SLTranMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SLTranMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                UserID = res.data.Flag.UserID
                //console.log("SLTranMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("SLTranMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("SLTranMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("IntRMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    useEffect(() => {
        if (logviewonly === "Y") {
            setViewMode("L")
        }

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/SLUser', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "SLTran", 
                        cAction: "ViewLogRec"
                    })
                    console.log("SLTranMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])
 


    const PrevRecProcess = async (LocationTran: SLTranInfo) => {
        try {
            //console.log("call PrevRecProcess", LocationTran)
            const res = await gsb.post('/SLUser', {sb_data: LocationTran, cPgmId: "SLTran", cAction: "PrevRec"})
            //console.log("PrevRecProcess show 1: ", stk.d_Seq)
            //console.log("PrevRecProcess data : ", data)
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Tran_type === res.data.data.d_Tran_type) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setcurrentLocationTran(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (LocationTran: SLTranInfo) => {
        try {
            LocationTran.d_AuthTran = ""
            if (isReqAuth2) {
                LocationTran.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/SLUser', {sb_data: LocationTran, cPgmId: "SLTran", cAction: "DelRec"})
            if (isReqAuth2) {
                showSuccess("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type + " record deleting, waiting for authorization")
            } else {
                showSuccess("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type  + " record deleted")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Tran_type === res.data.data.d_Location) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentLocationTran(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type + " record deleting, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (LocationTran: SLTranInfo) => {
        try {
            //console.log("call NextRecProcess", LocationTran)
            const res = await gsb.post('/SLUser', {sb_data: LocationTran, cPgmId: "SLTran", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Tran_type === res.data.data.d_Location) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentLocationTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (LocationTran: SLTranInfo) => {
        try {
            //console.log("call newOnSave", LocationTran)
            isReqValueLimitAuth2 =  false
            const res = await gsb.post('/SLUser', {sb_data: LocationTran, cPgmId: "SLTran", cAction: "AddRec"})
            //showSuccess("Seq No. " + LocationTran.d_Seq + " record added")
            if (isReqAuth2) {
                showSuccess("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type + " record adding, waiting for authorization")
            } else {
                showSuccess("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type + " record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Tran_type === res.data.data.d_Location) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentLocationTran(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                //alert("Seq No. " + res.data.data.d_Seq + " record adding, over value limit waiting for authorization")
                setisShowAlert1(true)
                setShowAlert1Msg("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type + " record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (LocationTran: SLTranInfo) => {
        try {
            //console.log("call editOnSave", LocationTran)
            //console.log("stk.d_CcassStk: ", stk.d_CcassStk)
            isReqValueLimitAuth2 =  false
            const res = await gsb.post('/SLUser', {sb_data: LocationTran, cPgmId: "SLTran", cAction: "UpdateRec"})
            if ( res.data.data.d_Auth_Value_Limit_tran === "Y" ) {
                isReqValueLimitAuth2 =  true
            }
            if (isReqAuth2) {
                showSuccess("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Tran_type === res.data.data.d_Location) {
                        setcurrentLocationTran(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                //alert("Seq No. " + LocationTran.d_Seq + " record saving, over value limit waiting for authorization")
                setisShowAlert1(true)
                setShowAlert1Msg("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type + " record saving, waiting for authorization")
            } else {
                showSuccess("Stock " + LocationTran.d_StkNo +", "+ LocationTran.d_Tran_type + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Tran_type === res.data.data.d_Location) {
                        data[i] = { ...data[i], ...res.data.data }
                        //console.log("editOnSave data", i, data)
                        setData(data)
                        //setCurrentStk(stk)
                        break
                    }
                }   
                //console.log("editOnSave stk", stk)
                //console.log("editOnSave res.data.data", res.data.data)
                setcurrentLocationTran(res.data.data)
                setCurrentMode("show")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        // get SLTran list if StkNo have value
        try {
            //console.log("SLTranMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/SLUser',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            StkNo: searchStkNo,
                        }, 
                    },
                    cPgmId: "SLTran",
                    cAction: "ListRec",
                });

                //console.log("SLTranMain onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentLocationTran(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/SLUser',
                {   sb_data: {
                        StkNo: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "SLTran",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentLocationTran(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    // get one SLTran record if StkNo have value
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            // console.log("calling API for URL param");

            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("SLTranMain useEffect length > 0  called", data)
                const res = await gsb.post('/SLUser',
                    {   sb_data: {
                            by: searchKey,
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "SLTran",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentLocationTran(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/SLUser',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                StkNo: searchStkNo,
                            }, 
                        },
                        cPgmId: "SLTran",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentLocationTran(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    // currentMode = show
    let detail = <SLTranView gsb={gsb} LocationTran={currentLocationTran} LocationTran0={currentLocationTran} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentLocationTran)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentLocationTran)} onNextRec={() => NextRecProcess(currentLocationTran)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></SLTranView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <SLTranEdit gsb={gsb} LocationTran={BlankLocationTran} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></SLTranEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <SLTranEdit gsb={gsb} LocationTran={currentLocationTran} onSave={editOnSave} onCancel={() => setCurrentMode("show")} ></SLTranEdit>
            break
        }

    let logKeyViewRec = <SLTranView gsb={gsb} LocationTran={CurrentLog1} LocationTran0={CurrentLog0} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentLocationTran)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentLocationTran)} onNextRec={() => NextRecProcess(currentLocationTran)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></SLTranView>

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>


    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-StkNo">Stock No</th>
                <th className="TCol-StkCode">Stock Code</th>
                <th className="TCol-Type">Type</th>
                <th className="TCol-TDate">Date</th>
                <th className="TCol-Location">From Location </th>
                <th className="TCol-Location">To Location </th>
                <th className="TCol-Qty">Qty </th>
            </thead>
            <tbody id="ma_tr">
                {data.map((LocationTran, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-StkNo" onClick={() => { setcurrentLocationTran(LocationTran) ; MoblieDev && setSelectedTabId("detail") }}>{LocationTran.d_StkNo}</td>
                        <td className="TCol-StkCode" onClick={() => { setcurrentLocationTran(LocationTran) ; MoblieDev && setSelectedTabId("detail") }}>{LocationTran.d_StkCode}</td>
                        <td className="TCol-Type" onClick={() => { setcurrentLocationTran(LocationTran) ; MoblieDev && setSelectedTabId("detail") }}>{LocationTran.d_Tran_type}</td>
                        <td className="TCol-TDate" onClick={() => { setcurrentLocationTran(LocationTran) }}>{LocationTran.d_Tran_date}</td>
                        <td className="TCol-Location" onClick={() => { setcurrentLocationTran(LocationTran) }}>{LocationTran.d_Fm_Location}</td>
                        <td className="TCol-Location" onClick={() => { setcurrentLocationTran(LocationTran) }}>{LocationTran.d_To_Location}</td>
                        <td className="TCol-Qty" onClick={() => { setcurrentLocationTran(LocationTran) }}>{utils.formatNumber2(LocationTran.d_TranQty)}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Stock Location Transaction Entry</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for Stock Location " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="_recordNo">Record No</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    disabled
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" )} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" )} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                        </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-1" label="Stock No." labelFor="searchStkNo">
                                <InputGroup id="searchStkNo" value={searchStkNo} onChange={utils.handleStringChange(s => setsearchStkNo(s))} />
                            </FormGroup>
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Stock Location Transaction Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default SLTranMain